export default __webpack_public_path__ + "static/media/icons8-hvac.74df6748.svg";